export const createCertificate = ({ BeURL, certifications, setCertificate, showAlert }) => {

    fetch(`${BeURL}/candidate-certificate`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ certifications }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setCertificate(data.certificate)
                window.location.reload()

            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in create certifications", err);
        });
}
